import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { XmButtonModule, XmTooltipModule } from '@optek/xm-bootstrap';
import { MapComponent } from './map.component';
import { MapService } from './map.service';
import { ContainerWidgetComponent } from './widgets/container-widget/container-widget.component';



@NgModule({
  imports: [
    CommonModule,
    XmTooltipModule,
    XmButtonModule,
  ],
  declarations: [
    MapComponent,
    ContainerWidgetComponent,
  ],
  exports: [
    MapComponent
  ],
  providers: [
    MapService
  ]
})
export class MapModule { }
